var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-feature',{attrs:{"id":"feature","features":_vm.features,"title":_vm.$t('header.feature')}}),_vm._v(" "),_c('div',{staticClass:"section-divider"}),_vm._v(" "),_c('more-feature',{attrs:{"apps":_vm.apps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }